<template>
    <v-container fluid class="pa-4">
        <v-card>
            <v-card-title class="text-h6">
                <v-icon left color="primary">mdi-calendar-multiple</v-icon>
                Calendario Team
                <v-spacer></v-spacer>
                <v-btn icon @click="prevMonth"><v-icon>mdi-chevron-left</v-icon></v-btn>
                <span class="text-subtitle-1 mx-2">{{ monthLabel }}</span>
                <v-btn icon @click="nextMonth"><v-icon>mdi-chevron-right</v-icon></v-btn>
                <v-btn icon class="ml-2" @click="load" :loading="loading"><v-icon>mdi-refresh</v-icon></v-btn>
            </v-card-title>
            <v-card-text>
                <div class="calendar-grid">
                    <div class="day-header" v-for="d in ['Lun','Mar','Mer','Gio','Ven','Sab','Dom']" :key="d">{{ d }}</div>
                    <div
                        v-for="cell in cells"
                        :key="cell.key"
                        class="day-cell"
                        :class="{'other-month': !cell.inMonth, 'today': cell.isToday}">
                        <div class="day-number">{{ cell.day }}</div>
                        <div class="events">
                            <v-tooltip v-for="e in cell.events" :key="e.id + '-' + cell.key" top>
                                <template v-slot:activator="{ on }">
                                    <v-chip v-on="on" x-small :color="e.absence_type_color || 'blue'" text-color="white" class="mb-1 event-chip">
                                        <v-icon left x-small>{{ e.absence_type_icon || 'mdi-beach' }}</v-icon>
                                        {{ e.employee_full_name }}
                                    </v-chip>
                                </template>
                                <div>
                                    <strong>{{ e.employee_full_name }}</strong><br/>
                                    {{ e.absence_type_name }}<br/>
                                    {{ formatAbsenceRange(e.start_at, e.end_at, e.half_day) }}<br/>
                                    Stato: {{ e.status_text || e.status }}
                                </div>
                            </v-tooltip>
                        </div>
                    </div>
                </div>
            </v-card-text>
        </v-card>
    </v-container>
</template>

<script>
import { formatAbsenceRange, localDateStr } from '@/components/utilities/hrDates'
    export default {
        name: 'hr-team-calendar',

        data() {
            return {
                month: new Date(),
                events: [],
                loading: false,
            }
        },

        computed: {
            monthLabel() {
                return this.month.toLocaleDateString('it-IT', { month: 'long', year: 'numeric' })
            },
            cells() {
                const year = this.month.getFullYear()
                const month = this.month.getMonth()
                const firstDay = new Date(year, month, 1)
                const lastDay = new Date(year, month + 1, 0)
                // Monday-first
                const jsDay = firstDay.getDay()
                const offset = jsDay === 0 ? 6 : jsDay - 1
                const startDate = new Date(year, month, 1 - offset)
                const today = new Date()
                const cells = []
                for (let i = 0; i < 42; i++) {
                    const d = new Date(startDate.getFullYear(), startDate.getMonth(), startDate.getDate() + i)
                    const inMonth = d.getMonth() === month
                    const key = localDateStr(d)
                    const events = this.events.filter(e => {
                        const s = new Date(e.start_at); s.setHours(0, 0, 0, 0)
                        const en = new Date(e.end_at); en.setHours(23, 59, 59, 999)
                        return d >= s && d <= en
                    })
                    cells.push({
                        key,
                        day: d.getDate(),
                        inMonth,
                        isToday: d.toDateString() === today.toDateString(),
                        events,
                    })
                    if (d > lastDay && !inMonth && i >= 34) break
                }
                return cells
            },
        },

        methods: {
            load() {
                this.loading = true
                const year = this.month.getFullYear()
                const month = this.month.getMonth()
                const from = localDateStr(new Date(year, month, 1))
                const to = localDateStr(new Date(year, month + 1, 0))
                this.axios.get(`hrabsences/team-calendar?from=${from}&to=${to}`).then(r => {
                    this.events = r.data.events || []
                    this.loading = false
                }, () => { this.loading = false })
            },
            prevMonth() { this.month = new Date(this.month.getFullYear(), this.month.getMonth() - 1, 1); this.load() },
            nextMonth() { this.month = new Date(this.month.getFullYear(), this.month.getMonth() + 1, 1); this.load() },
            formatAbsenceRange,
        },

        created() {
            this.$store.commit('endProgress')
            this.load()
        },
    }
</script>

<style scoped>
.calendar-grid {
    display: grid;
    grid-template-columns: repeat(7, 1fr);
    gap: 2px;
    background: #e0e0e0;
}
.day-header {
    background: #fafafa;
    padding: 6px 4px;
    text-align: center;
    font-weight: 600;
    font-size: 12px;
    color: #666;
}
.day-cell {
    background: #fff;
    min-height: 96px;
    padding: 4px;
    display: flex;
    flex-direction: column;
    gap: 2px;
}
.day-cell.other-month {
    background: #f5f5f5;
    color: #aaa;
}
.day-cell.today .day-number {
    background: #ffc107;
    color: #000;
    border-radius: 50%;
    width: 24px;
    height: 24px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    font-weight: 700;
}
.day-number {
    font-size: 12px;
    font-weight: 500;
    margin-bottom: 2px;
}
.events {
    display: flex;
    flex-direction: column;
    gap: 1px;
    overflow: hidden;
}
.event-chip {
    max-width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}
</style>
